import { useQuery } from '@apollo/client';
import { Queries } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';

const useGetPaystubs = country => {
  const context = useAuthContext('paystubs:read');
  const { loading, error, data } = useQuery(Queries.GetPaystubs, {
    variables: { country },
    pollInterval: 60000,
    context,
  });
  if (loading) {
    return [[], loading, null];
  }
  if (error) {
    return [[], false, error];
  }
  return [data?.getCurrentUser?.paystubs || [], false, null];
};

export default useGetPaystubs;
